import React from "react";
import { Alert, Box } from "@mui/material";
import {
  ToggleOn as ToggleOnIcon,
  ToggleOff as ToggleOffIcon,
  Warning as WarningIcon,
} from "@mui/icons-material";
import { ReportGenUser } from "../../../shared/interfaces/User";
import { ConfirmDialog } from "../../../shared/ui";

export interface UserStatusDialogProps {
  open: boolean;
  action: "activate" | "deactivate" | null;
  user: ReportGenUser | null;
  isUpdating: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const UserStatusDialog: React.FC<UserStatusDialogProps> = ({
  open,
  action,
  user,
  isUpdating,
  onClose,
  onConfirm,
}) => {
  const isActivate = action === "activate";

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={() => {
        if (action && !isUpdating) {
          void onConfirm();
        }
      }}
      tone={isActivate ? "success" : "error"}
      iconVariant="tinted"
      icon={isActivate ? <ToggleOnIcon /> : <ToggleOffIcon />}
      title={isActivate ? "Reactivate User" : "Deactivate User"}
      description={
        <>
          Are you sure you want to {isActivate ? "reactivate" : "deactivate"}{" "}
          <Box component="span" fontWeight={600} color="text.primary">
            {user ? `${user.firstName} ${user.lastName}` : "this user"}
          </Box>
          ?
        </>
      }
      confirmLabel={isActivate ? "Reactivate" : "Deactivate"}
      confirmStartIcon={isActivate ? <ToggleOnIcon /> : <ToggleOffIcon />}
      loading={isUpdating}
      confirmDisabled={!action}
    >
      {!isActivate && (
        <Alert
          severity="warning"
          sx={{ mt: 2, borderRadius: 2, textAlign: "left" }}
          icon={<WarningIcon fontSize="small" />}
        >
          This user will no longer be able to access the system.
        </Alert>
      )}
    </ConfirmDialog>
  );
};

export default UserStatusDialog;
